import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'contactez-nous',
  en: 'contact-us'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Contactez-nous',
      en: 'Contact Us'
    },
    description: {
      fr: 'Cette page vous fournit les coordonnées nécessaires pour nous contacter, que vous soyez un citoyen ou un établissement de santé.',
      en: 'This page provides the contact details you need to reach us, whether you are a citizen or a healthcare facility.'
    }
  },
  component: () => import('@page/contactUs/ContactUs.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
